"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameType = exports.StreamingMethod = exports.StreamType = exports.ContentType = void 0;
// TODO: Add proper source docs to reference each fields raw meaning
//       Currently we just have a bunch of fields with a lack of "what" they should map to
//       Simple JSDocs for each field with example should do
var ContentType;
(function (ContentType) {
    ContentType["Premium"] = "premium video";
    ContentType["Free"] = "free video";
})(ContentType || (exports.ContentType = ContentType = {}));
var StreamType;
(function (StreamType) {
    StreamType["Linear"] = "linear";
    StreamType["VOD"] = "vod";
})(StreamType || (exports.StreamType = StreamType = {}));
var StreamingMethod;
(function (StreamingMethod) {
    StreamingMethod["Dtc"] = "dtc";
    StreamingMethod["Mvpd"] = "mvpd";
    StreamingMethod["Free"] = "free";
    StreamingMethod["Redemption"] = "redemption";
})(StreamingMethod || (exports.StreamingMethod = StreamingMethod = {}));
var GameType;
(function (GameType) {
    GameType["Live"] = "live";
    GameType["Replay"] = "replay";
})(GameType || (exports.GameType = GameType = {}));
